"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ClearIndicator = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _groupAddons = require("../group-addons");
var _Svg = require("../../../Svg");
var _templateObject;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var close = function close(props) {
  return /*#__PURE__*/_react.default.createElement("svg", props, /*#__PURE__*/_react.default.createElement("path", {
    d: "M6.99999 5.58599L11.95 0.635986L13.364 2.04999L8.41399 6.99999L13.364 11.95L11.95 13.364L6.99999 8.41399L2.04999 13.364L0.635986 11.95L5.58599 6.99999L0.635986 2.04999L2.04999 0.635986L6.99999 5.58599Z",
    fill: "currentColor"
  }));
};
close.defaultProps = {
  width: "14",
  height: "14",
  viewBox: "0 0 14 14",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var ClearIndicator = (0, _styledComponents.default)(_groupAddons.IconInputGroupAddon).attrs(function () {
  return {
    children: /*#__PURE__*/_react.default.createElement(_Svg.Svg, {
      color: "tertiaryShade",
      as: close,
      height: 12
    }),
    addonType: 'append',
    clickable: true
  };
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  position: absolute;\n  top: 0;\n  height: 100%;\n  right: 40px;\n  z-index: 0;\n  padding: 0 !important;\n"])));
exports.ClearIndicator = ClearIndicator;